module.exports = __webpack_public_path__ + "img/full.b588a1ef.png";